import { createAsyncAction, createStandardAction } from 'typesafe-actions'
import {
  RolePackageListReq,
  RolePackageListRes,
  CreateRolePackageReq,
  ActionRolePackageRes,
  DeleteRolePackageReq,
  UpdateRolePackageReq,
} from './types'

export const getRolePackageListAction = createAsyncAction(
  'ROLE_PACKAGE/GET_ROLE_PACKAGE_LIST_REQ',
  'ROLE_PACKAGE/GET_ROLE_PACKAGE_LIST_SUCCESS',
  'ROLE_PACKAGE/GET_ROLE_PACKAGE_LIST_FAILURE',
)<RolePackageListReq, RolePackageListRes, Error>()

export const createRolePackageAction = createAsyncAction(
  'ROLE_PACKAGE/CREATE_ROLE_PACKAGE_REQ',
  'ROLE_PACKAGE/CREATE_ROLE_PACKAGE_SUCCESS',
  'ROLE_PACKAGE/CREATE_ROLE_PACKAGE_FAILURE',
)<CreateRolePackageReq, ActionRolePackageRes, Error>()

export const updateRolePackageAction = createAsyncAction(
  'ROLE_PACKAGE/UPDATE_ROLE_PACKAGE_REQ',
  'ROLE_PACKAGE/UPDATE_ROLE_PACKAGE_SUCCESS',
  'ROLE_PACKAGE/UPDATE_ROLE_PACKAGE_FAILURE',
)<UpdateRolePackageReq, ActionRolePackageRes, Error>()

export const deleteRolePackageAction = createAsyncAction(
  'ROLE_PACKAGE/DELETE_ROLE_PACKAGE_REQ',
  'ROLE_PACKAGE/DELETE_ROLE_PACKAGE_SUCCESS',
  'ROLE_PACKAGE/DELETE_ROLE_PACKAGE_FAILURE',
)<DeleteRolePackageReq, ActionRolePackageRes, Error>()

export const clearEventAction = createStandardAction('ROLE_PACKAGE/CLEAR_EVENT')<void>()
